<template>
  <div
    v-show="showCompanyJobListWrapper"
    class="page-wrapper common-wrapper company-job-list-wrapper animated-page"
    :class="wrapperClass">
    <form
      v-if="!has_custom_mobile_landing_page"
      id="search-form" v-show="showSearchForm"
      @submit.prevent="_fetchJobList(false)"
      action="javascript:return true">
      <div class="search-keywords-container">
        <span class="search-keywords-icon" @click="_fetchJobList(false)"></span>
        <input
          ref="searchKeywordsCommon"
          class="search-keywords-common search-keywords"
          type="search"
          v-model="keywords"/>
        <span class="search-keywords-cancel" @click="onCancelClick()"></span>
      </div>
    </form>
    <input v-if="has_custom_mobile_landing_page" type="hidden" id="job-list" value="1" />
    <div v-if="has_custom_mobile_landing_page" class="current-company-info-custom">
      <div id="job-detail-information-contanier">
        <div id="preview-container" class="preview-container">
          <div class="preview-line1">
            <video
              v-if="isHeaderVideo"
              ref="headerVideo"
              id="header-bg"
              class="bg-preview video-preview"
              :src="headerSrc"
              autoplay
              muted
              loop
              playsinline
              webkit-playsinline
              @canplay="playHeaderVideo"
            >
            </video>
            <div
              v-else
              id="header-bg"
              class="header-bg"
              :class="header_image ? 'has-image' : ''"
              :style="headImgStyle">
            </div>
            <div id="logo-image"
              class="logo-image company-img"
              :class="company.logo ? 'has-logo' : ''"
              :style="`background-image: url(${$DjangoBaseUrl(company.logo)})`">
              <!-- :src="$DjangoMediaUrl(company.get_logo)" may error-->
            </div>
          </div>
          <div class="preview-line2">
            <div class="tool">
              <div class="left">
                <span id="menu-icon" class="prev-menu icomoon-menu" @click="$emit('onMenuIconClick')"></span>
              </div>
              <div class="right">
                <span v-if="showShareBtn" class="batch-sharing-icon" @click="$emit('share')">
                  <i class="icomoon-share"></i>
                </span>
                <a v-if="show_survey_entrance" class="company-survey-entrance" @click="onSurveyEntranceClick">
                  <span v-if="has_answered" class="iconfont iconcandidatesurvey-24 company-customized"></span>
                  <span v-else class="iconfont iconcandidatesurvey-23 shake-bell"></span>
                </a>
              </div>
              <div style="clear: both;" ></div>
            </div>
            <div class="desc" >
              <div id="preview-company-name" class="company-name">{{ company_webpage_title }}</div>
              <div id="preview-slogan" class="slogan">{{ slogan }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="nav"></div>
      <HoneywellFilter
        v-if="4335 === company.root_company.id"
        ref="HoneywellFilter"
        :search="search"
        :has_custom_mobile_landing_page="has_custom_mobile_landing_page"
        :company="company"
        :searchOverlay="searchOverlay"
        @clearSearch="$emit('clearSearch')"
        @fetchJobList="(loadMore, customized) => $emit('fetchJobList', loadMore, customized)"
        @showWrapper="_showWrapper"
        @showListLoading="(show) => $emit('showListLoading', show)"
        @showSearchForm="(show) => showSearchForm = show"
        @setkeywords="setkeywords"/>
      <CommonFilter
        v-else
        ref="CommonFilter"
        :search="search"
        :customized_page="customized_page"
        :has_custom_mobile_landing_page="has_custom_mobile_landing_page"
        :company="company"
        :show_salary="show_salary"
        :hide_trading_area="hide_trading_area"
        :searchOverlay="searchOverlay"
        :company_job_filter='company_job_filter'
        :company_job_filter_items='company_job_filter_items'
        :hasCustomFilter='hasCustomFilter'
        :isSearching='isSearching'
        @clearSearch="$emit('clearSearch')"
        @fetchJobList="(loadMore, customized) => $emit('fetchJobList', loadMore, customized)"
        @showWrapper="_showWrapper"
        @showListLoading="(show) => $emit('showListLoading', show)"
        @showSearchForm="(show) => showSearchForm = show"
        @setkeywords="setkeywords"/>
    </div>
    <div v-else class="search-field">
      <div class="current-company-info">
        <a class="back-to-container" @click="onBackIconClick">
          <div class="back-to"></div>
        </a>
        <router-link :to="`/recruiting/company/${company.id}/branding`">
          <img v-if="company.logo" class="company-image" :src="$DjangoBaseUrl(company.logo)" />
          <img v-else class="company-image" :src="$DjangoStaticUrl('images_en/default_company.jpg')" />
        </router-link>
        <span class="company-name">
          {{ languageCode === 'en' ? company.name : company.cn_name }}
        </span>
        <span class="clear-search" @click="clearSearch">{{ $t('common.clearSearch') }}</span>
      </div>
      <HoneywellFilter
        v-if="4335 === company.root_company.id"
        ref="HoneywellFilter"
        :search="search"
        :has_custom_mobile_landing_page="has_custom_mobile_landing_page"
        :company="company"
        :searchOverlay="searchOverlay"
        @clearSearch="$emit('clearSearch')"
        @fetchJobList="(loadMore, customized) => $emit('fetchJobList', loadMore, customized)"
        @showWrapper="_showWrapper"
        @showListLoading="(show) => $emit('showListLoading', show)"
        @showSearchForm="(show) => showSearchForm = show"
        @setkeywords="setkeywords"/>
      <CommonFilter
        v-else
        ref="CommonFilter"
        :search="search"
        :customized_page="customized_page"
        :has_custom_mobile_landing_page="has_custom_mobile_landing_page"
        :company="company"
        :show_salary="show_salary"
        :hide_trading_area="hide_trading_area"
        :searchOverlay="searchOverlay"
        :company_job_filter='company_job_filter'
        :company_job_filter_items='company_job_filter_items'
        :hasCustomFilter='hasCustomFilter'
        :isSearching='isSearching'
        @clearSearch="$emit('clearSearch')"
        @fetchJobList="(loadMore, customized) => $emit('fetchJobList', loadMore, customized)"
        @showWrapper="_showWrapper"
        @showListLoading="(show) => $emit('showListLoading', show)"
        @showSearchForm="(show) => showSearchForm = show"
        @setkeywords="setkeywords"/>
    </div>
    <!-- 确认创建提醒 -->
    <JobAlertConfirmDialog
      :show.sync="showJobAlertDialog"
      :companyId="company.id"
      :logo="company.logo"
      :isAgreed="personalAgreementStatus?.is_agreed"
    ></JobAlertConfirmDialog>
  </div>
</template>

<script>
import { getFilePath } from '@/utils/qiniu'
import CommonFilter from './filter/CommonFilter.vue'
import HoneywellFilter from './filter/HoneywellFilter.vue'
import JobAlertConfirmDialog from '@/components/job/jobDetail/jobAlertConfirmDialog.vue'
import { mapActions, mapGetters } from 'vuex'
import { ROOT_COMPANY_ID } from '@/constant/company'

export default {
  props: {
    has_custom_mobile_landing_page: {
      type: Boolean,
      required: true
    },
    header_image: {
      type: String
    },
    search: {
      type: Object,
      required: true
    },
    qiniu_domain: {
      type: String
    },
    company: {
      type: Object,
      required: true
    },
    account: {
      type: Object,
      required: true
    },
    isSearching: {
      type: Boolean,
      required: true
    },
    company_webpage_title: {
      type: String
    },
    slogan: {
      type: String
    },
    show_salary: {
      type: Boolean
    },
    hide_trading_area: {
      type: Boolean
    },
    searchOverlay: {
      type: Object
    },
    company_job_filter: {
      type: Array
    },
    company_job_filter_items: {
      type: Object
    },
    hasCustomFilter: {
      type: Boolean,
      default: false
    },
    show_survey_entrance: {
      type: Boolean,
      default: false
    },
    has_answered: {
      type: Boolean,
      default: false
    },
    showShareBtn: {
      type: Boolean,
      default: false
    },
    default_header_image: {
      type: String
    },
    personalAgreementStatus: {
      default: null
    },
    surveyInfo: {
      default: () => { }
    }
  },
  components: {
    CommonFilter,
    HoneywellFilter,
    JobAlertConfirmDialog
  },
  data () {
    return {
      showCompanyJobListWrapper: false,
      showSearchForm: false,
      keywords: null,
      showJobAlertDialog: false
    }
  },
  computed: {
    wrapperClass () {
      let className = ''
      if (this.has_custom_mobile_landing_page) {
        className = 'customed'
      } else {
        // className = 'hide'
      }
      if (this.company.id === 87) {
        className += ' apple_job_list_wrapper'
      }
      return className
    },
    customized_page () {
      return false // accor customized
    },
    languageCode () {
      return this.$i18n.locale
    },
    headerSrc () {
      return this.header_image ? getFilePath(this.header_image) : this.default_header_image
    },
    headImgStyle () {
      return {
        backgroundImage: `url(${this.headerSrc})`
      }
    },
    isHeaderVideo () {
      const key = this.header_image
      return Boolean(key && key.toLowerCase().split('?')[0].endsWith('.mp4'))
    },
    hasLogin () {
      const account = this.getCurrentAccount()
      return Boolean(account?.id)
    }
  },
  watch: {
    showCompanyJobListWrapper (visible) {
      if (!visible) {
        return
      }
      this.$nextTick(() => {
        this.playHeaderVideo()
      })
    }
  },
  created () {

  },
  mounted () {
    document.addEventListener('WeixinJSBridgeReady', this.playHeaderVideo, false)
  },
  beforeDestroy () {
    document.removeEventListener('WeixinJSBridgeReady', this.playHeaderVideo, false)
  },
  methods: {
    ...mapGetters('account', ['getCurrentAccount']),
    ...mapActions('job', ['unFollowCompany']),
    playHeaderVideo () {
      const video = this.$refs.headerVideo
      if (!video) {
        return
      }

      video.muted = true
      video.defaultMuted = true

      const play = () => {
        const playPromise = video.play()
        if (playPromise) {
          playPromise.catch(() => {})
        }
      }
      const bridge = window.WeixinJSBridge
      if (bridge && typeof bridge.invoke === 'function') {
        bridge.invoke('getNetworkType', {}, play)
      } else {
        play()
      }
    },
    onCancelClick () {
      if (this.isSearching) {
        if (this.company.root_company.id === 4335) {
          this.$refs.HoneywellFilter._showHideMask(false)
        } else {
          this.$refs.CommonFilter._showHideMask(false)
        }
        return
      }
      this.keywords = null
      this.search.keywords = null
      if (this.company.root_company.id === 4335) {
        this.$refs.HoneywellFilter.placeKeywords = null
        this.$refs.HoneywellFilter._showHideMask(false, '5') // TYPE_SEARCH = '5'
        this.$refs.HoneywellFilter.setSearchParams()
      } else {
        this.$refs.CommonFilter.placeKeywords = null
        this.$refs.CommonFilter._showHideMask(false, '5') // TYPE_SEARCH = '5'
        this.$refs.CommonFilter.setSearchParams()
      }
      this.$emit('fetchJobList')
    },
    _showWrapper (params) {
      for (const key in params) {
        if (key === 'company-job-list-wrapper') {
          this.showCompanyJobListWrapper = params[key]
          break
        }
      }
      this.$emit('showWrapper', params)
    },
    clearSearch () {
      if (this.isSearching) {
        if (this.company.root_company.id === 4335) {
          this.$refs.HoneywellFilter._showHideMask(false)
        } else {
          this.$refs.CommonFilter._showHideMask(false)
        }
        return
      }
      this.keywords = null
      if (this.company.root_company.id === 4335) {
        this.$refs.HoneywellFilter.onClearSearchClick()
      } else {
        this.$refs.CommonFilter.onClearSearchClick()
      }
    },
    onBackIconClick () {
      window.location.href = '/mobile-web-more-jobs/' + this.company.id
    },
    _fetchJobList (isLoadMore, customized) {
      if (this.isSearching) {
        if (this.company.root_company.id === 4335) {
          this.$refs.HoneywellFilter._showHideMask(false)
        } else {
          this.$refs.CommonFilter._showHideMask(false)
        }
        this.$refs.searchKeywordsCommon.blur()
        return
      }
      if (this.company.root_company.id === 4335) {
        this.$refs.HoneywellFilter._showHideMask(false, '5')
        this.$refs.HoneywellFilter.placeKeywords = this.keywords
        this.$refs.HoneywellFilter.setSearchParams()
      } else {
        this.$refs.CommonFilter._showHideMask(false, '5')
        this.$refs.CommonFilter.placeKeywords = this.keywords
        this.$refs.CommonFilter.setSearchParams()
      }
      this.search.keywords = this.keywords
      this.keywords = null
      this.$refs.searchKeywordsCommon.blur()
      this.$emit('fetchJobList', isLoadMore, customized)
    },
    setkeywords (keywords) {
      this.keywords = keywords
    },
    onSurveyEntranceClick () {
      if (this.hasLogin && !this.personalAgreementStatus) {
        return
      }
      if (this.surveyInfo.survey?.has_answered) {
        if (this.company.root_company?.id === ROOT_COMPANY_ID.MSD) {
          this.$router.push('/msdchina/join-talent-community')
        } else {
          this.$router.push(`/recruiting/company/${this.company.id}/survey`)
        }
      } else {
        this.showJobAlertDialog = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/shake.scss';
#main {
  .common-wrapper {
    #search-form {
      display: block;
    }

    ::v-deep {
      .policy-form {
        padding: 0;
      }
    }
  }
}

.preview-container {
  .preview-line1 {
    .video-preview {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .logo-image {
      position: relative;
      z-index: 1;
    }
  }

  .preview-line2 {
    .tool {
      .right {
        span {
          margin-left: unset;
        }

        .batch-sharing-icon {
          font-size: 26px;
        }
        .iconcandidatesurvey-24 {
          color: var(--custom-color);
        }
      }
    }
  }
}
</style>
